import type { FaireProductEntity } from "../../entity_types/product";

export const p_r6u3ve4mdz: FaireProductEntity = {
  token: "p_r6u3ve4mdz",
  type: "product",
  name: "New Escape/Puzzle Game | Board Game | The Secret Set",
  brandName: "Puzzle Post Games US",
  imageUrl:
    "https://cdn.faire.com/fastly/dbc8df0e1906de84b0c712010b06c2b071193a1d1e6cd54bcc9f3c177b37d0b6.png",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a8f8ab071eb70f72f710e1f88bdb9c3ef8a6c363435d360d0ea4fdf7aed06730.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
